import i18n from 'i18n';
import { RolesEnum } from 'modules/authenticate/interfaces';

export const mapPermissionName = (permission: RolesEnum | string) => {
  const permissionNameMap = {
    [RolesEnum.superAdmin]: i18n.t('ROLES.SUPERADMIN_KEY'),
    [RolesEnum.admin]: i18n.t('ROLES.ADMIN_KEY'),
    [RolesEnum.operator]: i18n.t('ROLES.OPERATOR_KEY'),
    [RolesEnum.clientOperator]: i18n.t('ROLES.CLIENT_OPERATOR_KEY'),
  };

  return permissionNameMap[permission] || '';
};
